
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/terminos-y-condiciones",
      function () {
        return require("private-next-pages/terminos-y-condiciones/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/terminos-y-condiciones"])
      });
    }
  